export default __webpack_public_path__ + "static/service-mesh-abstractions-ffb1928e797787a7befec293e9456748.webp";